<template>
	<el-container>
	  <!-- 始终渲染 headline -->
	  <headline :isCollapse='isCollapse' @Collapse="checkCollapse"></headline>
  
	  <el-container>
		<!-- 根据路由meta配置决定是否显示侧边栏 -->
		<el-aside 
		  v-if="!$route.meta.hideSidebarAndTabs" 
		  style="width: auto;">
		  <aside-menu :isCollapse='isCollapse'></aside-menu>
		</el-aside>
  
		<el-main :class="{'collapse-left': isCollapse}">
		  <!-- 使用插槽渲染具体页面的内容 -->
		  <slot></slot>
		</el-main>
	  </el-container>
	</el-container>
  </template>
<script>
	import header from './header.vue'
	import tabs from './tabs.vue'
	import menu from './menu.vue'
	export default {
		data() {
			return {
				isCollapse:false
			}
		},
		components:{
			tabs,
			'aside-menu':menu,
			'headline':header
		},
		methods:{
			checkCollapse(boolean){
				if (boolean) {
					this.collapseLeft = true
				}else{
					this.collapseLeft = false
				}
				this.isCollapse = boolean
			}
		},
		mounted(){
			if (document.body.clientWidth < 1500) {
				 this.isCollapse =true
			}
		}
	}
</script>

<style lang="stylus">
	.el-aside
		background #19197
		position fixed
		top 70px
		bottom 0
		left 0
		width 250px
		transition width 0.3s
		
	.el-main
		background #19197
		position absolute
		min-height 100%
		top 70px
		left 250px
		right 0
	
	.collapse-left
		transition .3s left 
		left 64px!important
</style>
